import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campSovReorder: FaireAdCampaignEntity = {
  token: "camp_sov_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_sweet_on_vermont",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 200,
  startedRunningAt: "2026-04-28",
  segmentMetrics: {
    numReorderConversions: 4,
    salesDollars: 1624,
    totalAdsSpendDollars: 115,
    returnOnAdSpend: 14.12,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-27T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
